import { Tenant } from '@wpp-open/core'

import { ApiQueryKeys } from 'constants/apiQueryKeys'
import { queryClient } from 'providers/osQueryClient/utils'
import { AssignmentType, FileItem } from 'types/files/files'
import { Hub } from 'types/hubs/hubs'

export enum FileTransferType {
  MOVE = 'move',
  COPY = 'copy',
}

export const isDestinationNotValid = (selectedHubId?: string, selectedFolderId?: string, files?: FileItem[]) => {
  const isHubSelected = !selectedFolderId && !!selectedHubId
  const isAllSourceLocationsValid = files?.reduce((acc, file) => {
    const filePath = file.metadata?.name?.split('/')
    const fileHubId = filePath[1]
    if (
      file.parentId === selectedFolderId ||
      (fileHubId === selectedHubId && isHubSelected && filePath?.length === 3)
    ) {
      return false
    }
    return acc
  }, true)
  return (!isHubSelected && !selectedFolderId) || !isAllSourceLocationsValid
}

export const invalidateDestination = (selectedFolderId?: string, selectedHub?: Hub, currentTenant?: Tenant) => {
  queryClient.invalidateQueries({
    queryKey: [
      ApiQueryKeys.FILES_SEARCH,
      {
        parentId: selectedFolderId,
        assignmentId: selectedHub?.id,
        assignmentType: AssignmentType.HUB,
        tenantId: currentTenant?.id,
      },
    ],
    exact: false,
  })
}
